<template>
  <v-container py-0>
    <v-progress-linear
      :active="loading"
      height="3"
      :indeterminate="true"
      class="my-1"
    />
    <v-card color="transparent" flat light>
      <v-card-text class="py-0">
        <v-layout row wrap>
          <v-flex md4 sm6 xs12 px-2>
            <v-autocomplete
              v-model="localProfile.position"
              :items="teamPositions"
              :label="
                $t('action.actions.select', {
                  field: $t('fields.global.position'),
                })
              "
              @focus="(e) => e.target.click()"
            />
          </v-flex>
          <v-flex md4 sm6 xs12 px-2>
            <v-text-field
              v-model="localProfile.dorsal"
              v-validate="'numeric'"
              type="number"
              :label="$t('fields.global.dorsal')"
              :data-vv-name="$t('fields.global.dorsal')"
              :error-messages="errors.collect($t('fields.global.dorsal'))"
            />
          </v-flex>
          <v-flex md4 sm6 xs12 px-2>
            <v-text-field
              v-model="localProfile.nationality"
              :label="$t('fields.users.nationality')"
            />
          </v-flex>
          <v-flex md4 sm6 xs12 px-2>
            <v-text-field
              v-model="localProfile.height"
              v-validate="'decimal'"
              type="number"
              :label="$t('fields.users.height') + ' (cm)'"
              :data-vv-name="$t('fields.users.height')"
              :error-messages="errors.collect($t('fields.users.height'))"
            />
          </v-flex>
          <v-flex md4 sm6 xs12 px-2>
            <v-text-field
              v-model="localProfile.weight"
              v-validate="'decimal'"
              type="number"
              :label="$t('fields.users.weight') + ' (Kg)'"
              :data-vv-name="$t('fields.users.weight')"
              :error-messages="errors.collect($t('fields.users.weight'))"
            />
          </v-flex>

          <v-flex sm4 xs12 px-2>
            <v-select
              v-model="localProfile.foot"
              :items="playerFoot"
              :label="$t('fields.users.foot')"
              @focus="(e) => e.target.click()"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />

        <meta-button type="update" :loading="loading" @click="submit()" />
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
export default {
  name: 'StepProfile',

  props: {
    profile: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      loading: (state) => state.users.loading,
      idSelected: (state) => state.users.idSelected,
    }),
    ...mapGetters({
      teamPositions: 'teams/teamPositions',
      playerFoot: 'users/playerFoot',
    }),
    localProfile: {
      get() {
        return this.profile
      },
      set(value) {
        this.$emit('update:profile', value)
      },
    },
  },
  methods: {
    ...mapActions({
      setProfile: 'users/updateProfile',
    }),
    submit() {
      let payload = Object.assign({}, this.localProfile)
      payload.userId = this.idSelected
      this.setProfile(payload)
    },
    clear() {
      this.$validator.reset()
    },
  },
}
</script>
